import { useEffect } from 'react';
import { getLoginRedirectURL } from '../../utilities/checkCookie';
import { Loader } from '../../assets/Loader/Loader';

export function RedirectToLogin () {
  useEffect(() => {
    const handleRedirect = async () => {
      window.location = await getLoginRedirectURL();
    };

    handleRedirect();
  }, []);

  return <Loader type='fullScreen'/>;
}
